import type { CSS } from '@grupoboticario/flora-react'

export const getLoadingBoxCss = (loading: boolean): CSS => ({
  display: loading ? 'block' : 'none',
  marginTop: '$4',
  textAlign: 'center'
})

export const tabListCss: CSS = {
  overflowX: 'auto'
}
